var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12"},[_c('div',{staticClass:"row d-flex justify-content-center"},[(this.stepsFiltered.length > 0)?_c('div',{staticClass:"col-10 mt-2"},[_c('el-card',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"py-3 px-5",staticStyle:{"border-radius":"10px","position":"relative","align-items":"center"},attrs:{"shadow":"always"}},[_c('div',{staticClass:"d-flex justify-content-center mb-4"},_vm._l((_vm.stepsFiltered.filter(
                function (x) { return x.key != 'completed' && x.key != 'business-contact'; }
              )),function(stepOption,index){return _c('div',{key:index,staticClass:"text-center",staticStyle:{"width":"200px"}},[_c('div',{staticClass:"status-requirements",class:[
                  {
                    'pending-action':
                      !stepOption.steps.includes(_vm.stepId) &&
                      _vm.onboardingAccount.is_completed == false,
                  },
                  {
                    pending:
                      stepOption.steps.includes(_vm.stepId) &&
                      _vm.onboardingAccount.is_completed == false,
                  },
                  {
                    approved:
                      Math.max.apply(Math, stepOption.steps) < _vm.stepId ||
                      _vm.onboardingAccount.is_completed == true,
                  } ],staticStyle:{"position":"relative"}},[_c('i',{staticClass:"fa fa-check-circle",staticStyle:{"font-size":"65px","position":"absolute","left":"-2px","top":"-2px"}})]),_vm._v(" "),_c('div',{staticClass:"mt-2 status-requirements-text",class:[
                  {
                    'pending-action':
                      !stepOption.steps.includes(_vm.stepId) &&
                      _vm.onboardingAccount.is_completed == false,
                  },
                  {
                    pending:
                      stepOption.steps.includes(_vm.stepId) &&
                      _vm.onboardingAccount.is_completed == false,
                  },
                  {
                    approved:
                      Math.max.apply(Math, stepOption.steps) < _vm.stepId ||
                      _vm.onboardingAccount.is_completed == true,
                  },
                  {
                    'font-weight-bold':
                      stepOption.steps.includes(_vm.stepId) &&
                      _vm.onboardingAccount.is_completed == true,
                  } ]},[_vm._v("\n                "+_vm._s(stepOption.title)+"\n              ")])])}),0),_vm._v(" "),_c('div',{staticClass:"flex-grow-1 onboarding-card d-flex flex-column justify-content-center"},[_c(_vm.componentsListFiltered.find(function (x) { return x.step_id == _vm.stepId; })
                  .component,{key:_vm.updateCount,tag:"component",staticClass:"h-100 bg-white",attrs:{"initial_lead":_vm.lead,"business-types":_vm.businessTypes,"profile_type_id":_vm.initial_onboarding_account.profile_type_id,"onboarding-account":_vm.onboardingAccount,"business-roles":_vm.businessRoles},on:{"update-lead":_vm.updateLead,"create-lead":_vm.createLead}})],1)])],1):_vm._e()])])])}
var staticRenderFns = []

export { render, staticRenderFns }